const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
const identifier = /^[a-z][a-z0-9_]{0,63}$/;
const finite = value => typeof value === 'number' && Number.isFinite(value) && Math.abs(value) <= 1e15;
const fail = (path, message = 'Revisa la definición de la calculadora.') => { throw { code: 'VALIDATION_FAILED', path, message }; };
const object = (value, keys, path) => {
  if (!value || typeof value !== 'object' || Array.isArray(value) || Object.keys(value).some(key => !keys.includes(key))) fail(path);
};
const list = (value, max, path) => { if (!Array.isArray(value) || value.length > max) fail(path); return value; };
const text = (value, max, path, optional = false) => { if (!(optional && value == null) && (typeof value !== 'string' || value.length > max)) fail(path); };

function validateDefinition(definition) {
  object(definition, ['engine', 'fields', 'constants', 'results', 'groups', 'presentation'], 'definition');
  const { engine } = definition;
  object(engine, ['kind', 'version'], 'engine');
  if (engine.version !== 1 || engine.kind !== 'custom') fail('engine');
  if (definition.presentation != null && !['cards', 'inline', 'table'].includes(definition.presentation)) fail('presentation');
  const fields = Object.create(null), constants = Object.create(null), results = Object.create(null), ids = new Set();
  const register = (row, path) => {
    if (typeof row.id !== 'string' || !identifier.test(row.id) || ids.has(row.id)) fail(path);
    ids.add(row.id); text(row.label, 200, path); text(row.unit, 200, path, true);
  };
  list(definition.fields, 50, 'fields').forEach(field => {
    object(field, ['id', 'type', 'label', 'help', 'unit', 'initial', 'required', 'min', 'max', 'options', 'visible_if'], 'fields');
    register(field, 'fields'); fields[field.id] = field;
    if (!['number', 'currency', 'percent', 'select'].includes(field.type)) fail(field.id);
    text(field.help, 2000, field.id, true);
    if (![true, false, null, undefined].includes(field.required)) fail(field.id);
    ['min', 'max'].forEach(key => { if (field[key] != null && !finite(field[key])) fail(field.id); });
    if (field.min != null && field.max != null && field.min > field.max) fail(field.id);
    if (field.type === 'select') {
      const options = list(field.options, 50, field.id);
      if (!options.length || new Set(options.map(option => option.value)).size !== options.length) fail(field.id);
      options.forEach(option => { object(option, ['value', 'label'], field.id); if (typeof option.value !== 'string') fail(field.id); text(option.label, 200, field.id); });
    }
    if (field.initial != null && (field.type === 'select' ? !field.options.some(option => option.value === field.initial) : !finite(field.initial))) fail(field.id);
  });
  list(definition.constants || [], 50, 'constants').forEach(constant => {
    object(constant, ['id', 'label', 'unit', 'value'], 'constants'); register(constant, 'constants');
    if (!finite(constant.value)) fail(constant.id); constants[constant.id] = constant;
  });
  list(definition.results, 50, 'results').forEach(result => {
    object(result, ['id', 'label', 'help', 'expression', 'format', 'unit', 'precision'], 'results'); register(result, 'results');
    text(result.help, 2000, result.id, true);
    if (!['number', 'currency', 'percent'].includes(result.format) || (result.precision != null && (!Number.isInteger(result.precision) || result.precision < 0 || result.precision > 6))) fail(result.id);
    results[result.id] = result;
  });
  if (!definition.results.length) fail('results');
  let nodes = 0;
  const nodeCheck = (node, depth) => { if (++nodes > 500 || depth > 20 || !node || typeof node !== 'object' || Array.isArray(node)) fail('expression'); };
  const graph = Object.create(null);
  function expression(node, deps, depth) {
    nodeCheck(node, depth);
    if (Object.keys(node).length === 1) {
      if (own(node, 'literal') && finite(node.literal)) return;
      if (own(node, 'input') && fields[node.input] && fields[node.input].type !== 'select') return;
      if (own(node, 'constant') && constants[node.constant]) return;
      if (own(node, 'result') && results[node.result]) { deps.push(node.result); return; }
    }
    if (node.op === 'if') {
      object(node, ['op', 'condition', 'then', 'else'], 'expression'); predicate(node.condition, deps, depth + 1);
      expression(node.then, deps, depth + 1); expression(node.else, deps, depth + 1);
    } else if (node.op === 'percent') {
      object(node, ['op', 'arg'], 'expression'); expression(node.arg, deps, depth + 1);
    } else if (['add', 'subtract', 'multiply', 'divide'].includes(node.op)) {
      object(node, ['op', 'args'], 'expression'); if (list(node.args, 2, 'expression').length !== 2) fail('expression');
      node.args.forEach(arg => expression(arg, deps, depth + 1));
    } else fail('expression', 'La operación o referencia no está disponible.');
  }
  function predicate(node, deps, depth, visibility = false) {
    nodeCheck(node, depth);
    if (['all', 'any'].includes(node.op)) {
      object(node, ['op', 'args'], 'condition'); if (!list(node.args, 10, 'condition').length) fail('condition');
      node.args.forEach(arg => predicate(arg, deps, depth + 1, visibility)); return;
    }
    object(node, ['op', 'left', 'right'], 'condition'); object(node.right, ['literal'], 'condition');
    if (!['eq', 'neq', 'lt', 'lte', 'gt', 'gte'].includes(node.op) || !node.left || Object.keys(node.left).length !== 1) fail('condition');
    const field = fields[node.left.input];
    if (field) {
      if (visibility && field.visible_if) fail('condition');
      if (field.type === 'select') {
        if (!['eq', 'neq'].includes(node.op) || !field.options.some(option => option.value === node.right.literal)) fail('condition');
      } else if (!finite(node.right.literal)) fail('condition');
    } else if (!visibility && results[node.left.result] && finite(node.right.literal)) deps.push(node.left.result);
    else fail('condition');
  }
  definition.results.forEach(result => { graph[result.id] = []; expression(result.expression, graph[result.id], 0); });
  const done = new Set();
  const visit = (id, path) => { if (path.includes(id)) fail(id, 'Hay una dependencia circular entre los resultados.'); if (done.has(id)) return; graph[id].forEach(dep => visit(dep, [...path, id])); done.add(id); };
  definition.results.forEach(result => visit(result.id, []));
  definition.fields.forEach(field => { if (field.visible_if) predicate(field.visible_if, [], 0, true); });
  const groups = new Set(), positions = [];
  list(definition.groups, 20, 'groups').forEach(group => {
    object(group, ['id', 'label', 'help', 'items'], 'groups');
    if (!identifier.test(group.id) || groups.has(group.id)) fail('groups'); groups.add(group.id); text(group.label, 200, 'groups'); text(group.help, 2000, 'groups', true);
    list(group.items, 100, 'groups').forEach(item => { object(item, ['kind', 'id'], 'groups'); if (!(item.kind === 'field' ? fields[item.id] : item.kind === 'result' && results[item.id])) fail('groups'); positions.push(item.id); });
  });
  if (positions.sort().join(',') !== [...Object.keys(fields), ...Object.keys(results)].sort().join(',')) fail('groups');
  return { fields, constants, results };
}

const messages = { REQUIRED: 'Completa este campo.', INVALID_INPUT: 'Introduce un valor válido.', OUT_OF_RANGE: 'El valor está fuera de los límites.', division_by_zero: 'No se puede dividir para cero.', missing_input: 'Falta una entrada válida.', numeric_range: 'El resultado está fuera del rango numérico.' };
const error = code => ({ code, message: messages[code] || 'No se puede calcular con estas entradas.' });
function evaluateDefinition(definition, inputs = {}) {
  const { fields, constants, results } = validateDefinition(definition);
  const values = Object.create(null), computed = Object.create(null);
  const unavailable = reason => { throw { unavailable: true, reason }; };
  const states = definition.fields.map(field => {
    const raw = inputs[field.id]; let value = raw, code;
    if (raw == null || raw === '') { value = null; if (field.required) code = 'REQUIRED'; }
    else if (field.type === 'select' ? !field.options.some(option => option.value === raw) : !finite(raw)) code = 'INVALID_INPUT';
    else if (field.type !== 'select' && ((field.min != null && raw < field.min) || (field.max != null && raw > field.max))) code = 'OUT_OF_RANGE';
    if (!code && value != null && field.type === 'percent') { value /= 100; if (raw !== 0 && value === 0) code = 'numeric_range'; }
    values[field.id] = code ? null : value;
    return { field_id: field.id, visibility: 'visible', errors: code ? [error(code)] : [] };
  });
  function expr(node) {
    if (own(node, 'literal')) return node.literal;
    if (own(node, 'input')) { if (values[node.input] == null) unavailable('missing_input'); return values[node.input]; }
    if (own(node, 'constant')) return constants[node.constant].value;
    if (own(node, 'result')) { const result = calculate(node.result); if (!result.available) unavailable(result.reason); return result.value; }
    if (node.op === 'if') return expr(pred(node.condition) ? node.then : node.else);
    const a = expr(node.op === 'percent' ? node.arg : node.args[0]), b = node.op === 'percent' ? 100 : expr(node.args[1]);
    if (node.op === 'divide' && b === 0) unavailable('division_by_zero');
    const value = node.op === 'add' ? a + b : node.op === 'subtract' ? a - b : node.op === 'multiply' ? a * b : a / b;
    if (!Number.isFinite(value) || (['multiply', 'divide', 'percent'].includes(node.op) && value === 0 && a !== 0 && b !== 0)) unavailable('numeric_range');
    return value;
  }
  function pred(node) {
    if (['all', 'any'].includes(node.op)) { const values = node.args.map(pred); return node.op === 'all' ? values.every(Boolean) : values.some(Boolean); }
    const left = expr(node.left), right = node.right.literal;
    return node.op === 'eq' ? left === right : node.op === 'neq' ? left !== right : node.op === 'lt' ? left < right : node.op === 'lte' ? left <= right : node.op === 'gt' ? left > right : left >= right;
  }
  states.forEach(state => {
    const field = fields[state.field_id]; if (!field.visible_if) return;
    try { state.visibility = pred(field.visible_if) ? 'visible' : 'hidden'; } catch (e) { if (!e.unavailable) throw e; state.visibility = 'undetermined'; }
    if (state.visibility !== 'visible') { values[field.id] = null; state.errors = []; }
  });
  function calculate(id) {
    if (computed[id]) return computed[id];
    const config = results[id]; let value = null, reason = null;
    try {
      value = expr(config.expression);
    } catch (e) { if (!e.unavailable) throw e; reason = e.reason; value = null; }
    return (computed[id] = { result_id: id, available: reason == null, value, value_state: reason == null ? 'available' : 'not_disclosed', reason,
      display_label: reason == null ? null : 'N.D.', format: config.format, unit: config.unit, precision: config.precision == null ? 2 : config.precision, errors: reason ? [error(reason)] : [] });
  }
  return { field_states: states, results: definition.results.map(result => calculate(result.id)) };
}

// The retained value lets a chart mounted after its calculator receive the first result.
const subscriptions = new Map();
function publishResults(id, value) { const slot = subscriptions.get(id) || { listeners: new Set() }; slot.value = value; subscriptions.set(id, slot); slot.listeners.forEach(listener => listener(value)); }
function subscribeResults(id, listener) { const slot = subscriptions.get(id) || { listeners: new Set() }; subscriptions.set(id, slot); slot.listeners.add(listener); if (slot.value) listener(slot.value); return () => { slot.listeners.delete(listener); if (!slot.listeners.size && !slot.value) subscriptions.delete(id); }; }
function clearResults(id) { const slot = subscriptions.get(id); if (slot) { slot.value = null; slot.listeners.forEach(listener => listener([])); if (!slot.listeners.size) subscriptions.delete(id); } }

module.exports = { validateDefinition, evaluateDefinition, publishResults, subscribeResults, clearResults };
